import { DynamicStandaloneYoutube } from '@/components/Youtube';
import { LabradorComponent } from '@/types/component';
import withDebugMetadata from '@/utils/withDebugMetadata';

const LabradorYoutube: LabradorComponent = ({ type, meta, data }) => {
  return (
    <DynamicStandaloneYoutube
      data-content-index={meta.contentIndex}
      vidID={data.vidID}
      {...withDebugMetadata({ type, meta })}
    />
  );
};

export default LabradorYoutube;
